import React from "react";
import Tooltip from '../../../../ui-kit/ToolTip/TooltipLabel';
import { FaCircleInfo } from "react-icons/fa6";

interface LabelWithTooltipProps {
  translations: any[];
  locale: string;
  mainColor: string;
  isRequired?: any;
  title?: any;
  title_sv?: any;
  description?: string;
  description_sv?: string;
  tooltip?: boolean;
  h2Title?: boolean;
}

const LabelWithTooltip: React.FC<LabelWithTooltipProps> = ({
  translations,
  locale,
  mainColor,
  isRequired,
  title,
  title_sv,
  description,
  description_sv,
  tooltip = false,
  h2Title = false,
}) => {
  const label =
    translations.find((translation: any) => translation.language_code === locale)
      ?.translated_name || "";

  return (
    <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: 6, marginBottom: 5 }}>
      <div style={{ display: "flex", flexDirection: "row", gap: 3}}>
   
             <p style={{fontWeight: 'bold'}}>{label}</p> 

        {isRequired && <p style={{ color: mainColor }}>*</p>}
      </div>
      {(tooltip && (description || description_sv || title || title_sv)) && (
        <Tooltip
          title={
            <div>
               <p style={{fontSize: 12, textAlign: 'left', fontWeight: 'bold', marginBottom: 3}}>{locale === "en" ? title || title_sv : title_sv || title}</p>
              <div style={{ fontWeight: "normal", textAlign: "left", fontSize: 10}}>
                {locale === "en" ? description || description_sv  : description_sv || description}
              </div>
            </div>
          }
        >
          <span style={{ cursor: "pointer", alignSelf: "center", display: "flex" }}>
            <FaCircleInfo size={18} color={mainColor} />
          </span>
        </Tooltip>
      )}
    </div>
  );
};

export default LabelWithTooltip;